import _ from 'lodash';

const regexNumber = /^\d+$/;

/**
 * Returns whether a DNI (Documento Nacional de Identidad) is valid.
 */
function isDNI (value) {
    if (!_.isString(value) || value.length < 7 || value.length > 8) {
        return false;
    }
    return regexNumber.test(value);
}

export default isDNI;
